<div class="{{localService.selectedLanguageCode}}" *ngIf="localService.languageContent && localService.languageContent.table">
  <div class="banner center" style="max-width:600px;">
    <div class="row row_header freeze_height">
      <div class="col-5">
        {{localService.languageContent.table.action}}
      </div>
      <div class="col-7">
        {{localService.languageContent.table.title}}
        <div class="icon_action_header">
          <i class="material-icons on_language_changed" (click)="onLoad()">replay_circle_filled</i>
          <i class="material-icons" (click)="onAction(1)" title="{{localService.languageContent.common.add}}">note_add</i>
        </div>
      </div>
    </div>
    <div *ngIf="wrapper" class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
      <div class="row styled_row" *ngFor="let item of wrapper.items">
        <div class="col-5">
          <i class="material-icons button icon_adjust" title="{{item.isSelected ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}" (click)="onAction(2,item.key)" [ngStyle]="{'color': item.isSelected ? 'yellowgreen' : 'orangered' }">{{item.isSelected ? "toggle_on" : "toggle_off"}}</i>
          <a class="button" [routerLink]="['/menu-settings' + localService.basicParamsString,pageKey,item.key]"><i class="material-icons button icon_adjust">account_tree</i></a>
        </div>
        <div class="col-7">
          <span class="button" (click)="onAction(1,item.key)">{{item.v1}}</span>
        </div>
      </div>
    </div>
  </div>
  <app-paging *ngIf="wrapper" [paging]="wrapper.paging" [IsSimple]="true" [IsSimpleSearchBarReq]="false" (onPagingRefreshed)="onLoad()"></app-paging>
</div>
